<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card elevation="4" class="pa-4">
          <v-card-title class="text-center text-h4 my-4">
            Sign In
          </v-card-title>
          
          <v-card-text>
            <p class="text-body-1 text-center mb-6">
              Sign in to access your financial dashboard
            </p>
            
            <v-alert
              v-if="error"
              type="error"
              variant="tonal"
              class="mb-4"
            >
              {{ error }}
            </v-alert>
            
            <v-btn
              block
              color="primary"
              class="mb-4"
              size="large"
              @click="signInWithGoogle"
              :loading="loading"
            >
              <v-icon start icon="$mdiGoogle"></v-icon>
              Sign in with Google
            </v-btn>
            
            <div class="text-caption text-center mt-4">
              By continuing, you agree to our Terms of Service and Privacy Policy
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { signInWithGooglePopup, handleRedirectResult, signInWithGoogleRedirect, verifyToken } from '../firebase/auth';

export default {
  name: 'LoginView',
  data() {
    return {
      loading: false,
      error: null
    }
  },
  mounted() {
    // Check for redirect result when component mounts
    this.handleRedirect();
  },
  methods: {
    async signInWithGoogle() {
      this.loading = true;
      this.error = null;
      
      try {
        // Use popup for desktop and redirect for mobile
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        
        //if (!isMobile) {
          const { user } = await signInWithGooglePopup();
          await this.verifyAndUpdateUserSession(user);
        /*} else {
          // For mobile, we'll start the redirect flow
          // The result will be handled in handleRedirect on page reload
          signInWithGoogleRedirect();
        }*/
      } catch (error) {
        console.error("Login error:", error);
        this.error = "Failed to sign in with Google. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    
    async handleRedirect() {
      this.loading = true;
      
      try {
        const result = await handleRedirectResult();
        if (result) {
          await this.verifyAndUpdateUserSession(result.user);
        }
      } catch (error) {
        console.error("Redirect handling error:", error);
        this.error = "Failed to complete the sign-in process. Please try again.";
      } finally {
        this.loading = false;
      }
    },
    
    async verifyAndUpdateUserSession(user) {
      try {
        // Verify the token with the backend
        const isValid = await verifyToken();
        
        if (isValid) {
          console.log("Login.vue Token verified successfully");
          this.handleSuccessfulLogin(user);
        } else {
          throw new Error("Token verification failed");
        }
      } catch (error) {
        console.error("Token verification error:", error);
        this.error = "Authentication failed. Please try again.";
        throw error;
      }
    },
    
    handleSuccessfulLogin(user) {
      // You can add any post-login logic here
      console.log("Logged in user:", user);
      
      // Check if there's a redirect query parameter
      const redirectPath = this.$route.query.redirect || '/';
      
      // Redirect to the intended destination or home page
      this.$router.push(redirectPath);
    }
  }
}
</script>
